import { useMutation } from "@tanstack/react-query";
import { AuthApi } from "../routes/auth";
import { authLogger } from "../Utils/logger";

export const useLogin = () => {
  return useMutation({
    mutationFn: async (data) => {
      try {
        authLogger.apiRequest("POST", "/login", { email: data.email });
        const res = await AuthApi.login(data);
        authLogger.apiResponse("POST", "/login", res.data, 200);
        return res.data.data;
      } catch (error) {
        authLogger.apiError("POST", "/login", error, error.response?.status);
        authLogger.userAction("login_failed", {
          email: data.email,
          error: error.message,
        });
        throw error;
      }
    },
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: async () => {
      try {
        authLogger.userAction("logout_initiated");
        const res = await AuthApi.logout();
        authLogger.userAction("logout_success");
        return res;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/user/logout",
          error,
          error.response?.status,
        );
        authLogger.userAction("logout_failed", { error: error.message });
        throw error;
      }
    },
  });
};

export const useRegister = () => {
  return useMutation({
    mutationFn: async (data) => {
      try {
        authLogger.apiRequest("POST", "/register-agora", { email: data.email });
        const res = await AuthApi.register(data);
        authLogger.apiResponse("POST", "/register-agora", res.data, 200);
        authLogger.userAction("registration_success", { email: data.email });
        return res;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/register-agora",
          error,
          error.response?.status,
        );
        authLogger.userAction("registration_failed", {
          email: data.email,
          error: error.message,
        });
        throw error;
      }
    },
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: async (data) => {
      try {
        authLogger.apiRequest("POST", "/forgot-password", {
          email: data.email,
        });
        const res = await AuthApi.forgotPassword(data);
        authLogger.apiResponse("POST", "/forgot-password", res.data, 200);
        authLogger.userAction("forgot_password_requested", {
          email: data.email,
        });
        return res;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/forgot-password",
          error,
          error.response?.status,
        );
        authLogger.userAction("forgot_password_failed", {
          email: data.email,
          error: error.message,
        });
        throw error;
      }
    },
  });
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: async (data) => {
      try {
        authLogger.apiRequest("POST", "/user/update/password");
        const res = await AuthApi.changePassword(data);
        authLogger.apiResponse("POST", "/user/update/password", res, 200);
        authLogger.userAction("password_changed_success");
        return res;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/user/update/password",
          error,
          error.response?.status,
        );
        authLogger.userAction("password_change_failed", {
          error: error.message,
        });
        throw error;
      }
    },
  });
};

export const useCheckUnique = () => {
  return useMutation({
    mutationFn: async (data) => {
      try {
        authLogger.apiRequest("POST", "/check-unique", { email: data.email });
        const res = await AuthApi.checkUnique(data);
        authLogger.apiResponse("POST", "/check-unique", res.data, 200);
        authLogger.userAction("uniqueness_check", {
          email: data.email,
          emailUnique: res.data.email_unique,
          phoneUnique: res.data.phone_unique,
        });
        return res;
      } catch (error) {
        authLogger.apiError(
          "POST",
          "/check-unique",
          error,
          error.response?.status,
        );
        authLogger.userAction("uniqueness_check_failed", {
          email: data.email,
          error: error.message,
        });
        throw error;
      }
    },
  });
};
